import { render } from "./ActivityIntentions.vue?vue&type=template&id=4789316c&scoped=true"
import script from "./ActivityIntentions.vue?vue&type=script&lang=js"
export * from "./ActivityIntentions.vue?vue&type=script&lang=js"

import "./ActivityIntentions.vue?vue&type=style&index=0&id=4789316c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4789316c"]])

export default __exports__